<template>
  <div>
    <title>金世尊全国门店管理</title>
    <section class="mainPart">
      <!--S 检索-->      
      <el-form :inline="true" :model="distributeForm">
          <el-form-item label="关键词">
              <el-input clearable v-model="distributeForm.keyword" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" @click="search">查询</el-button>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" plain @click="getShowDepotDlog(sellType,'add',0)">新增</el-button>
          </el-form-item>
      </el-form>
      <!--E 检索-->
      <!-- S 列表 -->
      <div class="gsListTable individualiz">
        <!-- TODO: 筛选：一次只可选择一项，选中一个另外一个自动取消选中 -->
        <el-form :model="searchGLForm" inline size="medium">
          <el-form-item class="borderline borderNone">
            <em class="greyColor">状态</em>
            <el-checkbox-group v-model="searchGLForm.status" @change="statusChange" >
              <el-checkbox label="1">启用</el-checkbox>
              <el-checkbox label="0">禁用</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <el-table class="comTable orderTable" ref="gsTable" :data="payRecordList" border :maxHeight="tableHeight">
          <el-table-column label="序号" type="index" fixed prop="serial"></el-table-column>
          <el-table-column label="分销商名称" fixed sortable prop="flowname" min-width="200">
            <template slot-scope="scope">
              <p class="textFl" :title="scope.row.flowname">{{scope.row.flowname ||'--'}}</p>
              <small class="textFl greyColor" :title="scope.row.username">账号：{{scope.row.username ||'--'}}</small>
            </template>
          </el-table-column>
          <el-table-column label="联系人" min-width="200" sortable prop="mobile">
            <template slot-scope="scope">
              <p class="textFl" :title="scope.row.linkman">{{scope.row.linkman}}</p>
              <small class="commonNum textFl greyColor" :title="scope.row.mobile">{{scope.row.mobile|| scope.row.tel}}</small>
            </template>
          </el-table-column>
          <el-table-column label="详细地址" min-width="200">
            <template slot-scope="scope">
                <div class="pr70">
                    <p class="textFl">{{scope.row.province}}{{scope.row.city}}{{scope.row.district}}</p>
                    <small class="textFl greyColor" :title="scope.row.addrdet">{{scope.row.addrdet ||'--'}}</small>
                </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="授信额度（￥）" sortable min-width="200">
                <template slot-scope="scope">
                    <div class="creditIcon">
                        <em :title="`剩余${scope.row.curcanusequota}元`"><strong>{{scope.row.curcanusequota}}</strong><i class="remainIcon">剩</i></em>
                        <em :title="`已消耗${scope.row.usedquota}元`"><strong>{{scope.row.usedquota}}</strong><i class="usedIcon">消</i></em>
                        <em :title="`总共授信${scope.row.quota}元`"><strong>{{scope.row.quota}}</strong><i class="totalIcon">总</i></em>
                    </div>
                </template>
            </el-table-column>
          <el-table-column label="销售业务/折扣" sortable prop="isopensale" width="200">
            <template slot-scope="scope">
              <p class="xsyw">
                  <span :class="scope.row.isopensale?'blueColor':'orangeColor'">{{scope.row.isopensale?'已开通':'未开通'}}</span>
                  <b> / {{scope.row.disCount?scope.row.disCount+'折':'--'}}</b>
              </p>
            </template>
          </el-table-column> -->
          <!-- <el-table-column label="展示顺序" width="120" sortable prop="showpos">
            <template slot-scope="scope">
              <span class="priceFont">{{scope.row.showpos}}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="状态" sortable prop="status" width="120">
            <template slot-scope="scope">
              <el-switch :value="scope.row.status? true : false" @change="handleStatus(scope.row,scope.row.status)" :width="45" class="isSwitch" :active-text="scope.row.status?'启':'禁'"></el-switch>
            </template>
          </el-table-column>
           <el-table-column label="操作" width="120" fixed="right">
                <template slot-scope="scope">
                    <el-dropdown trigger="click">
                        <span class="el-dropdown-link">
                            全部操作<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" class="czblock">
                            <el-dropdown-item  class="defindDropdown">
                                <span @click="getShowDepotDlog(sellType,'detail',scope.row.flowcode)">详情</span>
                            </el-dropdown-item>
                            <el-dropdown-item  class="defindDropdown">
                                <span @click="getShowDepotDlog(sellType,'edit',scope.row.flowcode)">编辑</span>
                            </el-dropdown-item>
                            <el-dropdown-item  class="defindDropdown">
                                <span @click="gotoQuota(scope.row.flowcode)">额度管理</span>
                            </el-dropdown-item>
                            <el-dropdown-item  class="defindDropdown">
                                <span @click="gotoRepayment(scope.row.flowcode)">结算管理</span>
                            </el-dropdown-item>
                            <el-dropdown-item  class="defindDropdown">
                                <span @click="gotoTransactionRecordJsz(scope.row.flowcode)">交易记录</span>
                            </el-dropdown-item>
                            
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
            <template slot="empty">
                <div class="noData"><span>暂无数据</span></div>
            </template>	
        </el-table>
      </div>
      <!-- E 列表 -->
      <!-- S 分页 -->
        <Page :pageTotal="pageTotal" :currentPage="currentPage" :pageSize="pageSize" @nowPageParam="nowPageParam"></Page>
      <!-- E 分页 -->
    </section>
  </div>
</template>
<script>
import Api from '@/apis/api';
import { Message, MessageBox } from "element-ui";
export default {
  name: 'StoreManageJsz',
  data () {
    return {
       pageTotal:0, //总数
       currentPage:1, // 页数
       pageSize:30, // 条数
      sellType:this.$route.params.sellType,//销售类型：0：自己；1：有二级分销商
      //检索
      distributeForm: {
        keyword: "", //关键词
      },
      searchGLForm: {
        status: [],//状态
      },
      payRecordList:[
      ],
      tableHeight: window.innerHeight*.8, //表格动态高度
      operate:'',//操作，add:新增，edit:编辑，detail:详情
    }
  },
  watch: {
    $route() {
      this.sellType=this.$route.params.sellType;//接受路由带过来的变量，控制元素显隐
    },
  },
  components: {
    Page: resolve => require(["@/components/common/Page.vue"],resolve),
  },
  methods: {
    //进入额度管理页面
    gotoQuota(flowcode){
      this.$router.push({
        name:'额度管理金世尊',
        params:{
          sellType:this.sellType,
          flowcode:flowcode
        }
      })
    },
    //进入结算管理页面
    gotoRepayment(flowcode){
      this.$router.push({
        name:'结算管理金世尊',
        params:{
          sellType:this.sellType,
          flowcode:flowcode
        }
      })
    },
    //进入交易记录页面
    gotoTransactionRecordJsz(flowcode){
      this.$router.push({
        name:'交易记录金世尊',
        params:{
          sellType:this.sellType,
          flowcode:flowcode
        }
      })
    },

    //切换状态
    handleStatus(row,val){
      let valTxt = '';
      let status = 0;
      if(!val){
          valTxt = '启用';
          status = 1;
      }else{
          valTxt = '禁用';
          status = 0;
      }
      MessageBox.confirm(`确定需要${valTxt}吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
            ucodes:row.flowcode,
            status:status
        }
       Api.UPDATEFLOWSTATUS(params).then((res) => {
            if(res.data.status == '200'){
                this.$message.success(`${valTxt}成功`);
                this.getFlowList();
            }else{
                this.$message.error(res.data.message)
            }
        })
      }).catch(() => {});
    },
    // 进入门店编辑、详情页面
    getShowDepotDlog(sellType,operate,flowcode){
        this.sellType=sellType;
        this.operate = operate;
        this.$router.push({
          name:'全国门店管理操作金世尊',
          // path:'/StoreManageOperate',
          params:{
            sellType:sellType,
            operate:operate,
            flowcode:flowcode
          }
        })
        // this.depotVisible = true;
    },
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
      //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
      this.tableHeight = window.innerHeight - tbHeight - 130; 
    },
     nowPageParam(val,vals){
      this.pageSize = val;
      this.currentPage = vals;
      this.getFlowList();
    },
    search(){
      this.currentPage = 1;
      this.getFlowList();
    },
    statusChange(){
      if(this.searchGLForm.status.length > 1) {
          this.searchGLForm.status.splice(0,1)
      }
      this.currentPage = 1;
      this.getFlowList();
    },
    getFlowList(){
      let param = {
        flowname:this.distributeForm.keyword,
        objtype:7,
        pageparam:{
          pagesize: this.pageSize, //每页条数
          currentpage: this.currentPage, //当前页数
        }
      }
      if(this.searchGLForm.status[0]){
        param.status =  Number(this.searchGLForm.status[0]);
      }
      Api.GET_FLOWLIST(param).then(res =>{
        if(res.data.status=="200"){
            this.payRecordList = res.data.data;
            this.pageTotal = res.data.pagebean.totalnum;
            this.$refs.gsTable.bodyWrapper.scrollTop = 0;
        }else {
            this.pageTotal =0;
            this.payRecordList =[];
        }
      })
    }
  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted () {
    if (this.$route) {
        this.sellType=this.$route.params.sellType;//接受路由带过来的变量，控制元素显隐
    }
    this.getFlowList();
    //在dom渲染之后
    setTimeout(()=>{
      this.getHeight();
    },200)
  },
  destroyed(){ 
    window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
  }
}
</script>

<style scoped>
@import '../Css/style.css';
.mainPart {padding: 20px; height: calc(100% - 50px);}
.pr70 {padding-right: 70px;}
.creditIcon em{
    display: block;
    color: #333;
    font-size: 14px;
    margin: 5px 0;
}
.creditIcon em i{
    display: inline-block;
    height: 20px;
    width: 20px;
    color: #fff;
    border-radius: 50%;
    text-align: center;
    font-size: 12px;
    line-height: 20px;
    margin-left: 5px;
}
.creditIcon em .remainIcon{
    background: #f56262;
}
.creditIcon em .usedIcon{
    background: #f2962c;
}
.creditIcon em .totalIcon{
    background: var(--main-color);
}
.creditIcon em strong{
    min-width: 80px;
    text-align: left;
    display: inline-block;
    font-weight: 700;
}
.comTable .el-dropdown-link{
    cursor: pointer;
    color: var(--main-color);
}
.defindDropdown {padding: 0;}
.defindDropdown >>> span{display: block; padding: 0 20px;}
</style>


// WEBPACK FOOTER //
// src/views/ManageFolder/ManageJsz/StoreManageJsz.vue